import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { LoadingModule } from '@loading-lib/loading.module'
import { DocumentDownloadComponent } from './document-download.component'

@NgModule({
    declarations: [DocumentDownloadComponent],
    exports: [DocumentDownloadComponent],
    imports: [CommonModule, LoadingModule, MatIconModule, MatTooltipModule],
})
export class DocumentDownloadModule {}
